export default __webpack_public_path__ + "static/media/trailrun.03d31046.jpg";